import axios from "axios";
import { getToken } from "./getToken";

export const getLazyLoadingApiResponse = async (
  path: string,
  pageCount: number,
  pageLimit: number,
  facilityId?: any,
  isAvailable?: boolean,
  masterSearch?: boolean,
  isTaskAssignment?: boolean,
  isForChat?: boolean
) => {
  return await axios.get(`${process.env.REACT_APP_API_URL}/${path}`, {
    params: {
      pageNumber: pageCount || undefined,
      limit: pageLimit || undefined,
      facilityId: facilityId || undefined,
      isAvailable: isAvailable || undefined,
      masterSearch: masterSearch || undefined,
      ...(isTaskAssignment !== undefined && { isTaskAssignment }),
      ...(isForChat !== undefined && { isForChat }),
    },
    headers: {
      Authorization: `Bearer ${JSON.parse(getToken() || "")}`, // Attach the token
    },
  });
};

export const getLazyLoadingSearchApiResponse = async (
  path: string,
  search: string,
  name?: string,
  masterSearch?: boolean,
  isTaskAssignment?: boolean,
  isForChat?: boolean,
  // Backend defaults the page size to 10 when no limit is sent, which capped
  // every search dropdown at 10 results. Request a full set by default.
  limit: number = 100
) => {
  return await axios.get(`${process.env.REACT_APP_API_URL}/${path}`, {
    params: {
      [name ? name : "searchKey"]: search || undefined,
      limit: limit || undefined,
      masterSearch: masterSearch || undefined,
      ...(isTaskAssignment !== undefined && { isTaskAssignment }),
      ...(isForChat !== undefined && { isForChat }),
    },
    headers: {
      Authorization: `Bearer ${JSON.parse(getToken() || "")}`, // Attach the token
    },
  });
};

export const getLazyLoadingMedicineSearchApiResponse = async (
  path: string,
  search: string,
  facilityId: any,
  isAvailable: boolean
) => {
  return await axios.get(`${process.env.REACT_APP_API_URL}/${path}`, {
    params: {
      searchValue: search || undefined,
      facilityId: facilityId || undefined,
      isAvailable: isAvailable || undefined,
    },
    headers: {
      Authorization: `Bearer ${JSON.parse(getToken() || "")}`, // Attach the token
    },
  });
};
